// SATscoreCalculator.js

// Aesthetic color palette for the pie chart slices (updated to darker tones)
export const PIE_COLORS = [
  '#A7B38D', // Darker CCD5AE
  '#C7D0A2', // Darker E9EDC9
  '#DBC07E', // Darker FEFAE0
  '#C4AB6D', // Darker FAEDCD
  '#A07C4A', // Darker D4A373
  '#4E5343', // Darker 6B705C
  '#9D7260', // Darker CB997E
];

export const mathMappings = [
  { min: 0, max: 0, score: 200 },
  { min: 1, max: 1, score: 200 },
  { min: 2, max: 2, score: 220 },
  { min: 3, max: 3, score: 240 },
  { min: 4, max: 4, score: 250 },
  { min: 5, max: 5, score: 260 },
  { min: 6, max: 6, score: 270 },
  { min: 7, max: 7, score: 280 },
  { min: 8, max: 8, score: 300 },
  { min: 9, max: 9, score: 320 },
  { min: 10, max: 10, score: 330 },
  { min: 11, max: 11, score: 340 },
  { min: 12, max: 12, score: 350 },
  { min: 13, max: 13, score: 360 },
  { min: 14, max: 14, score: 370 },
  { min: 15, max: 15, score: 380 },
  { min: 16, max: 16, score: 390 },
  { min: 17, max: 17, score: 400 },
  { min: 18, max: 18, score: 420 },
  { min: 19, max: 19, score: 440 },
  { min: 20, max: 20, score: 450 },
  { min: 21, max: 21, score: 460 },
  { min: 22, max: 22, score: 470 },
  { min: 23, max: 23, score: 480 },
  { min: 24, max: 24, score: 490 },
  { min: 25, max: 25, score: 500 },
  { min: 26, max: 26, score: 510 },
  { min: 27, max: 27, score: 530 },
  { min: 28, max: 28, score: 540 },
  { min: 29, max: 29, score: 550 },
  { min: 30, max: 30, score: 560 },
  { min: 31, max: 31, score: 570 },
  { min: 32, max: 32, score: 580 },
  { min: 33, max: 33, score: 600 },
  { min: 34, max: 34, score: 620 },
  { min: 35, max: 35, score: 640 },
  { min: 36, max: 36, score: 660 },
  { min: 37, max: 37, score: 680 },
  { min: 38, max: 38, score: 700 },
  { min: 39, max: 39, score: 720 },
  { min: 40, max: 40, score: 740 },
  { min: 41, max: 41, score: 760 },
  { min: 42, max: 42, score: 770 },
  { min: 43, max: 43, score: 790 },
  { min: 44, max: 44, score: 800 },
];

export const englishMappings = [
  { min: 0, max: 0, score: 200 },
  { min: 1, max: 1, score: 200 },
  { min: 2, max: 2, score: 220 },
  { min: 3, max: 3, score: 240 },
  { min: 4, max: 4, score: 260 },
  { min: 5, max: 5, score: 270 },
  { min: 6, max: 6, score: 280 },
  { min: 7, max: 7, score: 290 },
  { min: 8, max: 8, score: 300 },
  { min: 9, max: 9, score: 300 },
  { min: 10, max: 10, score: 310 },
  { min: 11, max: 11, score: 310 },
  { min: 12, max: 12, score: 320 },
  { min: 13, max: 13, score: 330 },
  { min: 14, max: 14, score: 340 },
  { min: 15, max: 15, score: 360 },
  { min: 16, max: 16, score: 370 },
  { min: 17, max: 17, score: 390 },
  { min: 18, max: 18, score: 410 },
  { min: 19, max: 19, score: 420 },
  { min: 20, max: 20, score: 430 },
  { min: 21, max: 21, score: 440 },
  { min: 22, max: 22, score: 450 },
  { min: 23, max: 23, score: 460 },
  { min: 24, max: 24, score: 470 },
  { min: 25, max: 25, score: 480 },
  { min: 26, max: 26, score: 490 },
  { min: 27, max: 27, score: 500 },
  { min: 28, max: 28, score: 510 },
  { min: 29, max: 29, score: 520 },
  { min: 30, max: 30, score: 530 },
  { min: 31, max: 31, score: 540 },
  { min: 32, max: 32, score: 550 },
  { min: 33, max: 33, score: 560 },
  { min: 34, max: 34, score: 570 },
  { min: 35, max: 35, score: 580 },
  { min: 36, max: 36, score: 590 },
  { min: 37, max: 37, score: 590 },
  { min: 38, max: 38, score: 600 },
  { min: 39, max: 39, score: 610 },
  { min: 40, max: 40, score: 630 },
  { min: 41, max: 41, score: 640 },
  { min: 42, max: 42, score: 650 },
  { min: 43, max: 43, score: 660 },
  { min: 44, max: 44, score: 670 },
  { min: 45, max: 45, score: 690 },
  { min: 46, max: 46, score: 700 },
  { min: 47, max: 47, score: 710 },
  { min: 48, max: 48, score: 720 },
  { min: 49, max: 49, score: 740 },
  { min: 50, max: 50, score: 750 },
  { min: 51, max: 51, score: 760 },
  { min: 52, max: 52, score: 770 },
  { min: 53, max: 53, score: 790 },
  { min: 54, max: 54, score: 800 },
];

export function convertCorrectAnswersToSAT(correctAnswers, subject) {
  const scoreMappings = subject === 'math' ? mathMappings : englishMappings;
  let found = scoreMappings.find(mapping => correctAnswers >= mapping.min && correctAnswers <= mapping.max);
  return found ? found.score : 200;
} 